export default "__VITE_ASSET__DCNYm9Tp__"